/* ---------------------------------------------------------------------------
   cart-upsell.js — "Jetzt profitieren und Sparen" (Warenkorb-Drawer)

   Die Empfehlungen selbst werden serverseitig in Liquid gerendert
   (snippets/cart-upsell.liquid). Dieses Script macht nur zwei Dinge:

     1. Plus-Button -> Produkt per AJAX in den bestehenden Warenkorb legen
        und den Drawer ueber die Theme-eigene CartDrawer.renderContents()
        aktualisieren. Dabei rendert das Liquid-Snippet neu, wodurch sich
        die Empfehlungen automatisch an den neuen Warenkorb anpassen.
     2. Produkte mit mehreren Varianten: Auswahl-Leiste unten im Kartenbild,
        die erst bei Bedarf /products/<handle>.js nachlaedt. Eine Options-
        gruppe pro Schritt, der Klick auf den letzten Wert legt direkt in den
        Warenkorb - es gibt keinen Bestaetigungsknopf.

   Alle Listener haengen delegiert am document, damit sie das Ersetzen des
   Drawer-Inhalts (innerHTML) ueberleben und nie doppelt gebunden werden.
   --------------------------------------------------------------------------- */

(function () {
  'use strict';

  if (window.cartUpsellInit) return;
  window.cartUpsellInit = true;

  var productCache = new Map();
  var inFlight = false;

  function root(el) {
    return el.closest('[data-cart-upsell]');
  }

  function strings(el) {
    var r = root(el);
    return {
      addUrl: (r && r.dataset.cuAddUrl) || (window.routes && window.routes.cart_add_url) || '/cart/add',
      error: (r && r.dataset.cuError) || 'Leider nicht verfügbar.',
      choose: (r && r.dataset.cuChoose) || 'Bitte Variante wählen',
      soldOut: (r && r.dataset.cuSoldOut) || 'Ausverkauft',
    };
  }

  function showError(card, message) {
    var box = card.querySelector('[data-cu-error-text]');
    if (box) box.textContent = message || '';
  }

  function setBusy(button, busy) {
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
    button.disabled = !!busy;
  }

  /* --- Warenkorb --------------------------------------------------------- */

  function addToCart(variantId, card, button) {
    if (inFlight) return;
    inFlight = true;
    setBusy(button, true);
    showError(card, '');

    var s = strings(button);

    fetch(s.addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok || !result.data || !result.data.sections) {
          throw new Error((result.data && result.data.description) || 'add_failed');
        }

        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') {
          // Ersetzt #CartDrawer komplett -> Empfehlungen, Preise und
          // Rabatte kommen frisch vom Server.
          drawer.renderContents(result.data);
        } else {
          window.location.reload();
        }
      })
      .catch(function (error) {
        /* eslint-disable-next-line no-console */
        console.error('[cart-upsell]', error);
        if (document.body.contains(card)) {
          showError(card, error && error.message !== 'add_failed' ? error.message : s.error);
          setBusy(button, false);
        }
      })
      .finally(function () {
        inFlight = false;
      });
  }

  /* --- Varianten-Auswahl -------------------------------------------------- */

  function fetchProduct(handle) {
    if (productCache.has(handle)) return Promise.resolve(productCache.get(handle));

    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'products/' + handle + '.js'
      : '/products/' + handle + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('product_fetch_failed');
        return response.json();
      })
      .then(function (product) {
        productCache.set(handle, product);
        return product;
      });
  }

  function optionNames(product) {
    if (!product.options || !product.options.length) return [];
    return product.options.map(function (option) {
      return typeof option === 'string' ? option : option.name;
    });
  }

  function variantOptions(variant) {
    return variant.options || [variant.option1, variant.option2, variant.option3];
  }

  function matchingVariant(product, selected) {
    return (
      product.variants.filter(function (variant) {
        var opts = variantOptions(variant);
        return selected.every(function (value, index) {
          return value === null || opts[index] === value;
        });
      })[0] || null
    );
  }

  function valueAvailable(product, selected, index, value) {
    var probe = selected.slice();
    probe[index] = value;
    return product.variants.some(function (variant) {
      if (!variant.available) return false;
      var opts = variantOptions(variant);
      return probe.every(function (selectedValue, i) {
        return selectedValue === null || opts[i] === selectedValue;
      });
    });
  }

  function valuesForOption(product, index) {
    var values = [];
    product.variants.forEach(function (variant) {
      var value = variantOptions(variant)[index];
      if (value && values.indexOf(value) === -1) values.push(value);
    });
    return values;
  }

  /* Eine Optionsgruppe pro Schritt. Der Klick auf einen Wert geht entweder
     weiter zur naechsten Gruppe oder legt - beim letzten Schritt - direkt in
     den Warenkorb. Es gibt bewusst keinen Bestaetigungsknopf: bei einem
     Produkt mit nur einer Groessen-Option ist "Plus -> Groesse antippen ->
     drin" damit genau ein Klick mehr als bei einem Ein-Varianten-Produkt. */
  function renderPicker(card, product) {
    var body = card.querySelector('[data-cu-picker-body]');
    var s = strings(card);
    var names = optionNames(product);
    var selected = names.map(function () {
      return null;
    });

    function draw(step) {
      body.innerHTML = '';
      showError(card, '');

      var head = document.createElement('div');
      head.className = 'cart-upsell__opt-head';

      if (step > 0) {
        var back = document.createElement('button');
        back.type = 'button';
        back.className = 'cart-upsell__opt-back';
        back.setAttribute('aria-label', 'Zurück');
        back.innerHTML =
          '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">' +
          '<path d="M12 4l-6 6 6 6" stroke="currentColor" stroke-width="1.8" ' +
          'stroke-linecap="round" stroke-linejoin="round"/></svg>';
        back.addEventListener('click', function () {
          selected[step] = null;
          selected[step - 1] = null;
          draw(step - 1);
        });
        head.appendChild(back);
      }

      var label = document.createElement('p');
      label.className = 'cart-upsell__opt-name';
      label.textContent = names[step] || s.choose;
      head.appendChild(label);
      body.appendChild(head);

      var list = document.createElement('div');
      list.className = 'cart-upsell__opt-values';

      var anyAvailable = false;

      valuesForOption(product, step).forEach(function (value) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'cart-upsell__opt-value';
        button.textContent = value;

        if (valueAvailable(product, selected, step, value)) {
          anyAvailable = true;
        } else {
          button.disabled = true;
        }

        button.addEventListener('click', function () {
          selected[step] = value;

          if (step + 1 < names.length) {
            draw(step + 1);
            return;
          }

          var variant = matchingVariant(product, selected);
          if (!variant || !variant.available) {
            showError(card, s.soldOut);
            return;
          }
          addToCart(variant.id, card, button);
        });

        list.appendChild(button);
      });

      body.appendChild(list);
      if (!anyAvailable) showError(card, s.soldOut);
    }

    draw(0);
  }

  function openPicker(card, button) {
    var picker = card.querySelector('[data-cu-picker]');
    var body = card.querySelector('[data-cu-picker-body]');
    if (!picker || !body) return;

    showError(card, '');
    picker.hidden = false;
    body.innerHTML = '<p class="cart-upsell__picker-loading">…</p>';

    fetchProduct(card.dataset.cuHandle)
      .then(function (product) {
        if (!document.body.contains(card)) return;
        if (!product.variants || !product.variants.length) throw new Error('no_variants');
        if (product.variants.length === 1) {
          picker.hidden = true;
          addToCart(product.variants[0].id, card, button);
          return;
        }
        renderPicker(card, product);
      })
      .catch(function (error) {
        /* eslint-disable-next-line no-console */
        console.error('[cart-upsell]', error);
        if (!document.body.contains(card)) return;
        picker.hidden = true;
        showError(card, strings(card).error);
      });
  }

  /* --- Delegierte Events --------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var closeButton = event.target.closest('[data-cu-picker-close]');
    if (closeButton) {
      var openCard = closeButton.closest('[data-cu-card]');
      if (openCard) openCard.querySelector('[data-cu-picker]').hidden = true;
      return;
    }

    var addButton = event.target.closest('[data-cu-add]');
    if (!addButton) return;

    var card = addButton.closest('[data-cu-card]');
    if (!card) return;

    event.preventDefault();

    var variantId = addButton.dataset.cuVariant;
    if (variantId) {
      addToCart(variantId, card, addButton);
    } else {
      openPicker(card, addButton);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('[data-cu-picker]:not([hidden])');
    if (open) {
      event.stopPropagation();
      open.hidden = true;
    }
  });
})();
